import script from "./SideBarComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SideBarComponent.vue?vue&type=script&setup=true&lang=js"

import "./SideBarComponent.vue?vue&type=style&index=0&id=60318634&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60318634"]])

export default __exports__